<template>
  <div class="app-container">
    <el-form ref="dataForm" :model="formData" label-width="120px">
      <el-tabs type="border-card">
        <el-tab-pane label="网站信息">
          <el-row :span="20">
            <el-col :span="10">
              <el-form-item label="网站LOGO">
                <FileList v-model="formData.website_logo" :item-width="100" :item-height="100" :limit="1" />
                <p class="el-upload__tip">网站logo图片大小为【296px x 296px】,后台和小程序共用</p>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="客服微信">
                <FileList v-model="formData.customer_service" :item-width="100" :item-height="100" :limit="1" />
                <p class="el-upload__tip">网站客服微信，教练申请咨询使用</p>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="5">
              <el-form-item label="网站ICO">
                <FileList v-model="formData.website_ico" :item-width="100" :item-height="100" :limit="1"/>
                <div class="el-upload__tip">网站ICO图片大小为【60px x 60px】</div>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row :span="18">
            <el-col :span="6">
              <el-form-item label="网站名称">
                <el-input v-model="formData.website_name" placeholder="请输入网站名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="支付限时">
                <el-input-number v-model="formData.order_timeout" :min="1" />
                <p class="el-upload__tip">未支付订单/排队成功，超过限时时间，自动取消。单位（分钟）</p>
              </el-form-item>
            </el-col>

            <!-- <el-col :span="6">
              <el-form-item label="蒙ICP备案">
                <el-input v-model="formData.icp_filing" placeholder="请输入蒙ICP备案"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="蒙公安网备">
                <el-input v-model="formData.filing" placeholder="请输入蒙公安网备"></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row :span="18">
            <el-form-item label="营业时间" prop="business_time">
              <el-col :span="6">
                <el-time-select
                  v-model="business_time[0]"
                  style="width: 100%"
                  :picker-options="{
                    start: '00:00',
                    step: '01:00',
                    end: '23:00',
                  }"
                  placeholder="选择开始时间"
                ></el-time-select>
                <p class="el-upload__tip">教练可进行排课的时间段</p>
              </el-col>
              <el-col :span="1" style="text-align: center">-</el-col>
              <el-col :span="6">
                <el-time-select
                  v-model="business_time[1]"
                  style="width: 100%"
                  :picker-options="{
                    start: '00:00',
                    step: '01:00',
                    end: '24:00',
                  }"
                  placeholder="选择结束时间"
                ></el-time-select>
              </el-col>
            </el-form-item>
            <!-- <el-col :span="6">
              <el-form-item label="营业时间">
                <el-time-picker
                  v-model="business_time"
                  is-range
                  range-separator="~"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  placeholder="选择时间范围"
                  format="HH:00"
                  value-format="HH:mm"
                >
                </el-time-picker>
                <p class="el-upload__tip">营业时间按整点设置</p> -->
          </el-row>
          <el-row :span="18">
            <el-col :span="6">
              <el-form-item label="会员卡退款限时">
                <el-input-number v-model="formData.card_refund_time" :min="0" precision="0" />
                <p class="el-upload__tip">会员卡退款限时，为0则不能退款。单位（天）</p>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row :span="18">
            <el-col :span="6">
              <el-form-item label="电话（传真）">
                <el-input v-model="formData.telephone" placeholder="请输入电话（传真）"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="邮编">
                <el-input v-model="formData.postal_code" placeholder="请输入邮编"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="官方地址">
                <el-input v-model="formData.website" placeholder="请输入官方地址"></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->
          <!-- <el-row :span="18">
            <el-col :span="18">
              <el-form-item label="版权信息">
                <el-input v-model="formData.copyright" placeholder="请输入版权信息"></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row :span="18">
            <el-col :span="18">
              <el-form-item label="关于我们" prop="content">
                <WangEditor v-model="formData.content" :value.sync="formData.content" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :span="18">
            <el-col :span="18">
              <el-form-item label="用户协议" prop="agreement">
                <WangEditor v-model="formData.agreement" :value.sync="formData.agreement" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :span="18">
            <el-col :span="18">
              <el-form-item label="隐私协议" prop="privacy_agreement">
                <WangEditor v-model="formData.privacy_agreement" :value.sync="formData.privacy_agreement" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <sticky :z-index="1000" direction="bottom">
      <el-card shadow="always" :body-style="{padding:'15px','text-align':'center'}">
        <el-button type="primary" icon="el-icon-upload" @click="SaveData()">提交</el-button>
      </el-card>
    </sticky>
  </div>
</template>

<script>
import Sticky from '@/components/Sticky' // 粘性header组件
import FileList from '@/components/attachment/FileList'

// import Tinymce from '@/components/Tinymce'
import api from '@/api/configure'
// import AttachmentList from '@/components/attachment/AttachmentList'
import commonList from '@/utils/commonList'
// import WangEditor from '@/components/WangEditor/index.vue'
import WangEditor from '@/components/WangEditor'
export default {
  components: {
    WangEditor,
    Sticky,
    FileList
    // AttachmentList
  },

  mixins: [commonList],
  data() {
    return {
      api,
      formData: {
        id: '',
        website_name: '',
        website_ico: '',
        website_logo: '',
        customer_service: '',
        website_weixin: '',
        volunteer: '',
        index_banner_link: '',
        index_banner: '',
        address: '',
        website: '',
        postal_code: '',
        telephone: '',
        filing: '',
        icp_filing: '',
        business_start_time: '',
        business_end_time: ''
      },
      business_time: []
    }
  },
  mounted: function() {
    this.fetchData()
  },
  methods: {
    SaveData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          if (this.business_time && this.business_time.length > 0) {
            this.formData.business_start_time = this.business_time[0]
            this.formData.business_end_time = this.business_time[1]
            if (this.formData.business_start_time >= this.formData.business_end_time) {
              this.$notify({ title: '', message: '营业的开始时间不能大于或等于结束时间', type: 'warning', duration: 2000 })
              return
            }
          }
          api.Save(this.formData).then((response) => {
            this.$notify({ title: '成功', message: response.message, type: 'success', duration: 2000 })
          })
        }
      })
    },
    fetchData() {
      api.Get().then(response => {
        if (response.data != null) {
          this.formData = response.data
          this.business_time = [this.formData.business_start_time, this.formData.business_end_time]
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
